import { FlightTeam, FlightDepartureStatus } from '../../../model';
import { formatFlightTime } from '../../../utils/formatters';
import { CustomerNotificationStatus } from '../../../store/features/departureBoard/departureBoardSlice';

export const getDepartureStatusTooltipContent = (item: FlightTeam) => {
    if (
        item.departureStatus === FlightDepartureStatus.Delayed &&
        (item.estimatedDepartureTime || item.estimatedDepartureTimeUtc)
    ) {
        return `Estimated: ${
            item.estimatedDepartureTime
                ? formatFlightTime(item.estimatedDepartureTime)
                : formatFlightTime(item.estimatedDepartureTimeUtc, true)
        }`;
    }

    if (
        item.departureStatus === FlightDepartureStatus.Departed &&
        (item.actualDepartureTime || item.actualDepartureTimeUtc)
    ) {
        return `Departed: ${
            item.actualDepartureTime
                ? formatFlightTime(item.actualDepartureTime)
                : formatFlightTime(item.actualDepartureTimeUtc, true)
        }`;
    }

    return undefined;
};

export const getBaggageStatus = (item: FlightTeam): CustomerNotificationStatus => {
    if (!item.bags?.length) {
        return CustomerNotificationStatus.NotAvailable;
    }

    return item.bags.every((b) => !!b.notifiedOnUtc)
        ? CustomerNotificationStatus.AllNotified
        : CustomerNotificationStatus.OutstandingActions;
};

export const getMisconnectedCustomersStatus = (
    item: FlightTeam
): CustomerNotificationStatus => {
    const passengersWithRebookedFlights =
        item.passengers?.filter((p) => p.rebookedFlights?.length) ?? [];

    if (passengersWithRebookedFlights.length === 0) {
        return CustomerNotificationStatus.NotAvailable;
    }

    return passengersWithRebookedFlights.some((x) =>
        x.rebookedFlights?.some((y) => !y.notifiedOnUtc)
    )
        ? CustomerNotificationStatus.OutstandingActions
        : CustomerNotificationStatus.AllNotified;
};

export const getConnectionStatus = (item: FlightTeam) => {
    return !item.brokerConnections?.length ? 'None' : item.brokerConnections[0].status;
};
